import { React, useEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Stack, Typography, Box, Button, Alert, Snackbar } from "@mui/material";
import Modal from "@mui/material/Modal";
import Select from "@mui/material/Select";
import TablePagination from "@mui/material/TablePagination";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { styled } from "@mui/material/styles";
import ConfirmPopup from "./ConfirmPopup";
import Checkbox from "@mui/material/Checkbox";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import FormControlLabel from "@mui/material/FormControlLabel";
import BatchScheduleAlert from "./BatchScheduleAlert";
import "./CourseMasterData.css";
import {
  updateTHStatus,
  getAllNominationDataTH,
  downloadSessionWiseNominatedList,
  updateCount,
  finaliseBatch,
  changeRejectStatusDataTH
} from "../Redux/THSlice";
import useMediaQuery from "@mui/material/useMediaQuery";

const THManageNominationCourselist = (props) => {
 const [filter, setFilter] = useState(2);
  const [page, setPage] = useState(0);
  const [openConfirmPopup, setOpenConfirmPopup] = useState(false);
  const [clickedID, setClickedId] = useState();
  const [checkedCount, setCheckedCount] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openModal, setOpenModal] = useState(false);

  const dispatch = useDispatch();

  let nominatedCount = useSelector(
    (state) => state.traininghost.nominatedCount
  );
  let rejectedCount = useSelector((state) => state.traininghost.rejectedCount);
  let waitlistCount = useSelector((state) => state.traininghost.waitlistCount);
  let scheduledCount = useSelector(
    (state) => state.traininghost.scheduledCount
  );
  let approvedCount = useSelector((state) => state.traininghost.approvedCount);

  let nominatedLearnersList = useSelector(
    (state) => state.traininghost.nominatedUserListTH
  );
  let nominatedLearnersListTemp = useSelector(
    (state) => state.traininghost.nominatedUserListOriginalData
  );
  let initialCheckboxStates = useSelector(
    (state) => state.traininghost.initialCheckboxStates
  );
  let dataSentSuccefully = useSelector(
    (state) => state.traininghost?.isDataSentSuccess ?? false
  )

  const [checkboxes, setCheckboxes] = useState(initialCheckboxStates);
  const [selectAll, setSelectAll] = useState(false);
  const [checkBoxid, setCheckBoxid] = useState([]);
  const [openFreezeAlert, setOpenFreezeAlert] = useState(false);
  useEffect(() => {
    setCheckboxes(initialCheckboxStates);
  }, [initialCheckboxStates]);
  useEffect(() => {
    let isFreezed = nominatedLearnersListTemp.some(
      (item) =>
        item.courseCode == props.courseCode &&
        item.startDate == props.startDate &&
        item.isFreeze == "yes"
    );
    isFreezed ? setOpenFreezeAlert(true) : setOpenFreezeAlert(false);
  }, [nominatedLearnersListTemp]);
  const handleCheckboxChange = (index, id) => {
    let newCheckboxes = [...checkboxes];

    newCheckboxes = newCheckboxes.map((obj) => {
      if (id in obj) {
        return { [id]: !obj[id] };
      }
      return obj;
    });

    setCheckboxes(newCheckboxes);
    const trueKeys = newCheckboxes.reduce((keys, obj) => {
      Object.entries(obj).forEach(([key, value]) => {
        if (value === true) {
          keys.push(key);
        }
      });
      return keys;
    }, []);

    setCheckBoxid(trueKeys);
    setCheckedCount(trueKeys.length);
    setSelectAll(newCheckboxes.every((obj) => Object.values(obj)[0] === true));
  };

  const handleCheckAllClick = () => {
    const newCheckboxes = checkboxes.map((obj) => {
      const updatedObj = {};
      for (const key in obj) {
        updatedObj[key] = !selectAll;
      }
      return updatedObj;
    });
    const trueKeys = newCheckboxes.reduce((keys, obj) => {
      Object.entries(obj).forEach(([key, value]) => {
        if (value === true) {
          keys.push(key);
        }
      });
      return keys;
    }, []);
    setCheckBoxid(trueKeys);
    setCheckboxes(newCheckboxes);
    setSelectAll(!selectAll);
    setCheckedCount(trueKeys.length);
  };
  const ColorButton = styled(Button)(({ theme }) => ({
    fontSize: "14px",
    padding: "5px",
    textTransform: "none",
    color: "white",
    background: "#8A2BE2",
    "&:hover": {
      backgroundColor: "#8A2BE2",
    },
  }));
  const ScheduleButton = styled(Button)(({ theme }) => ({
    fontSize: "14px",
    padding: "5px",
    textTransform: "none",
    color: "white",
    background: "#8A2BE2",
    "&:hover": {
      backgroundColor: "#8A2BE2",
    },
    "&:disabled": {
      background: "grey",
      border: "none",
      color: "white",
    },
  }));
  const openRejectStatusModal = () => {
    setOpenModal(true);
  };
  const closeRejectStatusModal = () => {
    setOpenModal(false);
  };
  const handleChangeFilter = (event) => {
    let filterValue = event.target.value;
    setFilter(event.target.value);
    dispatch(
      getAllNominationDataTH(props.courseCode, props.startDate, filterValue)
    );
    setCheckBoxid([]);
    setSelectAll(false);
  };
  const handleConfirmPopupOpen = () => {
    setOpenConfirmPopup(true);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleStatusUpdation = (status, prevStatus) => {
    dispatch(updateCount(checkedCount, status, prevStatus, filter));
    if (checkedCount > props.totalSeats && status == 4) {
      handleConfirmPopupOpen();
    } else {
      if (checkBoxid.length != 0) {
        dispatch(
          updateTHStatus(checkBoxid, status, 2, props.startDate, filter)
        );
        setCheckBoxid([]);
        setCheckboxes(initialCheckboxStates);
      }
    }
  };
  const changeRejectStatusHandler = (item) => {
const id = item.id;
const code = item.courseCode;
const startDate = item.startDate;
const status = (item.status == 3 || item.status == 5) ? 2 : ""
dispatch(changeRejectStatusDataTH(id, startDate, status, code, filter))
// dispatch(updateCount(checkedCount, status, prevStatus, filter));
setOpenModal(false)
  }
  const theme = createTheme({
    typography: {
      fontFamily: "Graphik-Regular",
    },
  });
  const handleFinaliseBatch = () => {
    setOpenFreezeAlert(true);
    dispatch(finaliseBatch(props.courseCode, props.startDate));
  };

  const GoBackButton = styled(Button)(({ theme }) => ({
    fontSize: "14px",

    textTransform: "none",
    // color: "white",
    color: "#8A2BE2",
    border: "solid 2px #8A2BE2 ",
    // "&:hover": {
    //  backgroundColor: "#8A2BE2",
    // },
  }));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <ThemeProvider theme={theme}>
      <Typography
        sx={{
          fontSize: "1.17em",
          margin: "20px 0px 10px 0px",
          fontWeight: "600",
        }}
      >
        Nomination List for {props.courseName}
      </Typography>
      <Box sx={{ width: "300px" }}>
        <GoBackButton
          onClick={() => {
            props.setIsSelected(false);
            props.setActivePage(false);
          }}
        >
          Go Back
        </GoBackButton>
        <GoBackButton
          sx={{ marginLeft: "20px" }}
          onClick={() => {
            handleFinaliseBatch();
          }}
        >
          Finalise Batch Schedule
        </GoBackButton>
      </Box>
      <Stack
        direction={"row"}
        sx={{ justifyContent: "center", alignItems: "center" }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "right",
            marginTop: "10px",
          }}
        >
          <Stack direction={"row"}>
            <Typography
              sx={{
                fontSize: isSmallScreen ? "12px" : "14px",
                color: "#696969	",
              }}
            >
              Total Seats Available :{" "}
              <span
                style={{
                  fontSize: isSmallScreen ? "14px" : "16px",
                  fontWeight: "600",
                  color: "blue",
                }}
              >
                {props.totalSeats}
              </span>
            </Typography>
            <Typography
              sx={{
                fontSize: isSmallScreen ? "12px" : "14px",
                color: "#696969	",
              }}
            >
              Number of Nominations Received :{" "}
              <span
                style={{
                  fontSize: isSmallScreen ? "14px" : "16px",
                  fontWeight: "600",
                  color: "blue",
                }}
              >
                {nominatedCount}
              </span>
            </Typography>
            <Typography
              sx={{
                fontSize: isSmallScreen ? "12px" : "14px",
                color: "#696969	",
              }}
            >
              Number of Nominations Approved :{" "}
              <span
                style={{
                  fontSize: isSmallScreen ? "14px" : "16px",
                  fontWeight: "600",
                  color: "blue",
                }}
              >
                {approvedCount}
              </span>
            </Typography>
            <Typography
              sx={{
                fontSize: isSmallScreen ? "12px" : "14px",
                color: "#696969	",
              }}
            >
              Number of Nominations Rejected :{" "}
              <span
                style={{
                  fontSize: isSmallScreen ? "14px" : "16px",
                  fontWeight: "600",
                  color: "blue",
                }}
              >
                {rejectedCount}
              </span>
            </Typography>
            <Typography
              sx={{
                fontSize: isSmallScreen ? "12px" : "14px",
                color: "#696969	",
              }}
            >
              Number of Nominations Scheduled :{" "}
              <span
                style={{
                  fontSize: isSmallScreen ? "14px" : "16px",
                  fontWeight: "600",
                  color: "blue",
                }}
              >
                {scheduledCount}
              </span>
            </Typography>
            <Typography
              sx={{
                fontSize: isSmallScreen ? "12px" : "14px",
                color: "#696969	",
              }}
            >
              Number of Nominations Cancelled :{" "}
              <span
                style={{
                  fontSize: isSmallScreen ? "14px" : "16px",
                  fontWeight: "600",
                  color: "blue",
                }}
              >
                {waitlistCount}
              </span>
            </Typography>
          </Stack>

          <Box
            sx={{
              width: isSmallScreen ? "500px" : "290px",
              display: "flex",
              justifyContent: "end",
            }}
          >
            <FormControl sx={{ m: 1, minWidth: 170 }} size="small">
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={filter}
                onChange={handleChangeFilter}
                displayEmpty
                sx={{
                  border: "solid 2px #7500C0",

                  color: "#7500C0",
                  fontWeight: "500",
                  padding: "0px !important",
                }}
              >
                <MenuItem sx={{ color: "#7500C0" }} value={6}>
                  All
                </MenuItem>
                <MenuItem sx={{ color: "#7500C0" }} value={1}>
                  waiting for Approval
                </MenuItem>
                <MenuItem sx={{ color: "#7500C0" }} value={2}>
                  Waiting for Batch Allocation
                </MenuItem>
                <MenuItem sx={{ color: "#7500C0" }} value={3}>
                  Rejected
                </MenuItem>
                <MenuItem sx={{ color: "#7500C0" }} value={4}>
                  Scheduled
                </MenuItem>
                <MenuItem sx={{ color: "#7500C0" }} value={5}>
                  Cancelled
                </MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
      </Stack>

      <Stack direction={"row"} alignItems={"center"}>
        <FormControlLabel
          control={
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon fontSize="medium" />}
              checkedIcon={<CheckBoxIcon fontSize="medium" />}
              checked={selectAll ? true : false}
              onClick={handleCheckAllClick}
            />
          }
          label={selectAll ? "Uncheck All" : "Check All"}
          labelPlacement="bottom"
          onClick={() => {
            handleCheckAllClick();
          }}
        />

        <Stack spacing={1} direction={"row"} sx={{ height: "fit-content" }}>
          {" "}
          <ScheduleButton
            type="small"
            onClick={() => {
              handleStatusUpdation(4, 2);
            }}
            disabled={filter == 4 ? true : false}
          >
            Schedule Batch
          </ScheduleButton>
          <ScheduleButton
            onClick={() => {
              handleStatusUpdation(5, 2);
            }}
          >
            Cancel
          </ScheduleButton>{" "}
        </Stack>
      </Stack>

      {nominatedLearnersList.length != 0 ? (
        <Box className="th_upload_fetch_table" sx={{ marginTop: "20px" }}>
          {/* status filter */}

          <Paper sx={{ width: "100% !important" }}>
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 650 }}
                size="small"
                aria-label="a dense table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell align="center"> </TableCell>
                    <TableCell align="center">Sl No</TableCell>
                    <TableCell align="center">Enterprise ID</TableCell>
                    <TableCell align="center">Nominated For</TableCell>
                    {filter == 2 || filter == 4 ? (
                      <TableCell align="center">Scheduled For</TableCell>
                    ) : null}
                    <TableCell align="center">Nominated Date</TableCell>
                    <TableCell align="center">Nominated Time</TableCell>
                    <TableCell align="center">Nominated By</TableCell>
                    <TableCell align="center">Status</TableCell>
                    <TableCell align="center">Change Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {nominatedLearnersList.length != 0 &&
                    nominatedLearnersList
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((item, index) => (
                        <TableRow key={item.sno}>
                          <TableCell align="center" scope="row">
                            {item.status == 2 || filter == 4 ? (
                              <Checkbox
                                checked={
                                  checkBoxid != undefined
                                    ? checkBoxid.includes(item.id) &&
                                      (item.status == 2 || item.status == 4)
                                      ? true
                                      : false
                                    : false
                                }
                                onChange={() =>
                                  handleCheckboxChange(item.sno, item.id)
                                }
                              />
                            ) : null}
                          </TableCell>
                          <TableCell align="center" scope="row">
                            {item.sno}
                          </TableCell>
                          <TableCell align="center">
                            {item.enterpriseID}
                          </TableCell>

                          <TableCell align="center">{item.startDate}</TableCell>
                          {filter == 2 || filter == 4 ? (
                            <TableCell align="center">
                              {item.status == 4 ? item.scheduledDate : ""}
                            </TableCell>
                          ) : null}

                          <TableCell align="center">{item.date}</TableCell>
                          <TableCell align="center">{item.time}</TableCell>
                          <TableCell align="center">
                            {item.nominatedBy}
                          </TableCell>
                          <TableCell align="center">
                            {item.status == 4 ? (
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  padding: "5px",
                                  color: "#8A2BE2",
                                  fontWeight: "600",
                                }}
                              >
                                Scheduled
                              </Typography>
                            ) : item.status == 5 ? (
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  padding: "5px",
                                  color: "red",
                                  fontWeight: "600",
                                }}
                              >
                                Cancelled
                              </Typography>
                            ) : item.status == 2 || filter == 2 ? (
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  padding: "5px",
                                  color: "#8A2BE2",
                                  fontWeight: "600",
                                }}
                              >
                                Waiting for Batch Allocation
                              </Typography>
                            ) : (
                              <Stack>
                                <Typography
                                  sx={{
                                    fontSize: "14px",
                                    border: "1px solid #a6a6a6",
                                    borderRadius: "5px",
                                    padding: "3px",
                                    textAlign: "center",
                                    color: item.status == 3 ? "red" : "blue",
                                  }}
                                >
                                  {item.status == 3 || filter ==3  
                                    ? "Rejected"
                                    : item.status == 1
                                    ? "Waiting for Approval"
                                    : ""}
                                </Typography>
                                {item.status == 3 && (
                                  <Typography
                                    sx={{
                                      fontSize: "12px",
                                      color: "red",
                                    }}
                                  >
                                    {item.reason}
                                  </Typography>
                                )}
                              </Stack>
                            )}
                          </TableCell>
                          <TableCell
                            align="center"
                            onClick={openRejectStatusModal}
                          >{
                            item.status == 3 &&
                            <Typography
                              className="approve-btn-for-reject"
                              sx={{
                                fontSize: "14px",
                                border: "1px solid #a6a6a6",
                                borderRadius: "5px",
                                padding: "3px",
                                textAlign: "center",
                                cursor: "pointer",
                                color: "blue",
                              }}
                            >
                              Approve
                            </Typography>
                            }
                          </TableCell>
                          <Modal
                            open={openModal}
                            onClose={closeRejectStatusModal}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                            sx={{ backgroundColor: "transparent" }}
                          >
                            <Box
                              sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                width: 600,
                                bgcolor: "background.paper",
                                border: "1px solid #000",
                                boxShadow: "3",
                                pt: 2,
                                px: 4,
                                pb: 3,
                              }}
                            >
                              <Typography
                                id="modal-modal-description"
                                sx={{
                                  mt: 2,
                                  mb: 3,
                                  textAlign: "center",
                                  fontSize: 15,
                                  color: "CaptionText",
                                }}
                              >
                                Are you sure want to change Rejected status to
                                Approved
                                <Typography sx={{display:"flex", justifyContent:"center", alignContent:"center"}}>
                              <span style={{color:"red"}}>*</span>
                              <p style={{color:"grey", fontStyle:"italic", fontSize:"12px", marginTop:"10px"}}>
                                (Once Approved status will reflect as Waiting for Batch Allocation.)</p>
                                </Typography>
                              </Typography>
                              <Typography sx={{ textAlign: "center" }}>
                                <Button
                                  variant="contained"
                                  size="small"
                                  sx={{ mr: 2 }}
                                  onClick={() => changeRejectStatusHandler(item)}
                                >
                                  YES
                                </Button>
                                <Button
                                  variant="contained"
                                  size="small"
                                  onClick={() => setOpenModal(false)}
                                >
                                  NO
                                </Button>
                              </Typography>
                            </Box>
                          </Modal>
                          {
                            dataSentSuccefully &&
                            <Snackbar
                            autoHideDuration={5000}
                            anchorOrigin={{ vertical: 'top', horizontal: 'right'}}
                            style = {{marginTop:'200px'}}
                            >
                              <Alert severity="success">Status Updated Successfully.!</Alert>
                            </Snackbar>
                          }
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              className="manageNomination_pagination"
              component="div"
              count={
                nominatedLearnersList.length != 0
                  ? nominatedLearnersList.length
                  : null
              }
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{ width: "100% !important" }}
            />
          </Paper>
        </Box>
      ) : (
        <Stack
          justifyContent={"center"}
          alignItems={"center"}
          sx={{ marginTop: "30px", marginBottom: "100px" }}
        >
          <Stack
            spacing={2}
            justifyContent={"center"}
            alignItems={"center"}
            sx={{
              border: "solid 1px #DEDEDE",
              borderRadius: "5px",
              width: "40%",
              padding: "30px",
            }}
          >
            <img
              style={{ width: "100px" }}
              src="/images/POC/norecords.png"
            ></img>
            <Stack direction={"row"} spacing={1}>
              <img
                style={{ width: "20px", height: "20px", marginTop: "3px" }}
                src="/images/POC/norecordsalert.png"
              ></img>
              <Typography>No Records Found</Typography>
            </Stack>
          </Stack>
        </Stack>
      )}
      <Box
        sx={{
          marginBottom: "40px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ColorButton
          onClick={() => {
            dispatch(
              downloadSessionWiseNominatedList(
                props.courseCode,
                props.startDate,
                filter
              )
            );
          }}
        >
          Download
        </ColorButton>
      </Box>
      <ConfirmPopup
        openConfirmPopup={openConfirmPopup}
        setOpenConfirmPopup={setOpenConfirmPopup}
        clickedID={clickedID}
      />
      <BatchScheduleAlert
        openFreezeAlert={openFreezeAlert}
        setOpenFreezeAlert={setOpenFreezeAlert}
      ></BatchScheduleAlert>
    </ThemeProvider>
  );
};

export default THManageNominationCourselist;
